import * as React from "react";

import { GTM_EVENT_BATMAID_LOGIN_STATE_CHANGED } from "@config/consts";

import { useAuth } from "@hooks/useAuth";
import { useGTM } from "@hooks/useGTM";

const Analytics = (): null => {
  const { isUserLoggedIn, isUserDataFetched, user } = useAuth();
  const gtm = useGTM();

  React.useEffect(() => {
    if (isUserDataFetched) {
      gtm.push({
        event: GTM_EVENT_BATMAID_LOGIN_STATE_CHANGED,
        isUserLoggedIn: String(isUserLoggedIn),
        ...(user?.get("hexHumanId") && {
          humanId: user?.get("hexHumanId"),
        }),
      });
    }
  }, [isUserLoggedIn, isUserDataFetched, user]);

  return null;
};

export { Analytics };
